import type { DomainSelectDto, DomainsSelectDto } from '@@types/api.types';
import { useAuth0 } from '@auth0/auth0-react';
import type { ApiErrorWrapper } from '@hooks/api.hook';
import { useApi } from '@hooks/api.hook';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from './keys';

export const useGetDomains = () => {
  const { apiGet } = useApi();
  const { isAuthenticated } = useAuth0();
  const enabled = isAuthenticated;

  return useQuery<DomainSelectDto[], ApiErrorWrapper>({
    enabled,
    queryFn: async () => {
      const result = await apiGet<DomainsSelectDto>({ path: '/v1/data/domains' });
      // The controller returns { domains: DomainSelectDto[] }, so we access result.domains
      return result.domains;
    },
    queryKey: queryKeys.domain.getDomains, // Assuming queryKeys.domains.getDomains exists or will be added
  });
};
